import React from 'react'

export const updateRef = <T>(
  x: T,
  ref: React.ForwardedRef<T> | undefined
): void => {
  if (typeof ref === 'function') {
    ref(x)
  } else if (ref) {
    ref.current = x
  }
}

export const cloneElementWithRef = <T, R>(
  element: React.FunctionComponentElement<T>,
  ref: React.ForwardedRef<R>
): React.FunctionComponentElement<T> =>
  React.cloneElement(element, {
    ref: (el: R) => {
      updateRef(el, ref)
      updateRef(el, element.ref as React.ForwardedRef<R>)
    }
  } as any)
